
import { useMutation } from "@tanstack/react-query";
import usePost from "./react-query-helpers/usePost.ts";
import instance from "../api/instance.ts";
import { toastError } from "../utils/helper.js";

export const usePostReviveAdultPolicy = () => {
    // return useMutation({
    //     mutationFn: async (data) => {
    //         try {
    //             const response = await instance.post('LapsedPolicy/RegisterLapsedPolicy', data);
    //             return response.data;
    //         } catch (error) {
    //             // Prevent the error from bubbling up to React DevTools
    //             toastError("Failed to revive policy. Please try again.");
    //             console.error('Error reviving policy:', error);
    //         }
    //     },
    //     onSuccess: (response) => {
    //         console.log('Policy revived successfully:', response);
    //     },
    //     onError: (error) => {
    //         // Log and show toast
    //         toastError("Failed to revive policy. Please try again.");
    //         console.error('Error reviving policy:', error);
    //     }
    // });
    return usePost();
};
